export default "__VITE_ASSET__ClH4zlLF__"